import { Routes } from '@angular/router';

import { FlamingoAuthGuard } from '@flamingo/guard/flamingo-auth.guard';

export const routes: Routes = [
    {
        path: '',
        canActivate: [FlamingoAuthGuard],
        loadComponent: () =>
            import('./children/main/main-layout.component').then(m => m.MainLayoutComponent),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'debtor'
            },
            {
                path: 'activities',
                loadComponent: () =>
                    import('./children/main/children/activities/activities.component').then(
                        m => m.ActivitiesComponent
                    )
            },
            {
                path: 'activities/new',
                loadComponent: () =>
                    import('./children/main/children/activities/children/new-activity/new-activity.component').then(
                        m => m.NewActivityComponent
                    )
            },
            {
                path: 'activities/:id',
                loadComponent: () =>
                    import('./children/main/children/activities/children/activity-detail/activity-detail.component').then(
                        m => m.ActivityDetailComponent
                    )
            },
            {
                path: 'activities/:id/edit',
                loadComponent: () =>
                    import('./children/main/children/activities/children/new-activity/new-activity.component').then(
                        m => m.NewActivityComponent
                    )
            },
            {
                path: 'debtor',
                loadComponent: () =>
                    import('./children/main/children/debtor/debtor.component').then(m => m.DebtorComponent)
            },
            {
                path: 'debtor/:id',
                loadComponent: () =>
                    import('./children/main/children/debtor/children/debtor-detail/debtor-detail.component').then(
                        m => m.DebtorDetailComponent
                    )
            },
            {
                path: 'valuations',
                loadComponent: () =>
                    import('./children/main/children/valuations/valuations.component').then(
                        m => m.ValuationsComponent
                    )
            },
            {
                path: 'supplier',
                loadComponent: () =>
                    import('./children/main/children/supplier/supplier.component').then(
                        m => m.SupplierComponent
                    )
            },
            {
                path: 'buyer',
                loadComponent: () =>
                    import('./children/main/children/buyer/buyer.component').then(m => m.BuyerComponent)
            },
            {
                path: 'invoices',
                loadComponent: () =>
                    import('./children/main/children/invoices/invoices.component').then(
                        m => m.InvoicesComponent
                    )
            },
            {
                path: 'receipts',
                loadComponent: () =>
                    import('./children/main/children/receipts/receipts.component').then(
                        m => m.ReceiptsComponent
                    )
            },
            {
                path: 'credits',
                loadComponent: () =>
                    import('./children/main/children/credits/credits.component').then(m => m.CreditsComponent)
            },
            {
                path: 'advances',
                loadComponent: () =>
                    import('./children/main/children/advances/advances.component').then(m => m.AdvancesComponent)
            },
            {
                path: 'users',
                loadComponent: () =>
                    import('./children/main/children/users/users.component').then(m => m.UsersComponent)
            },
            {
                path: 'users/new',
                loadComponent: () =>
                    import('./children/main/children/users/children/new-user/new-user.component').then(m => m.NewUserComponent)
            },
            {
                path: 'users/:id',
                loadComponent: () =>
                    import('./children/main/children/users/children/user-detail/user-detail.component').then(m => m.UserDetailComponent)
            }
        ]
    },
    {
        path: 'auth',
        loadChildren: () =>
            import('./children/authentication/authentication.routes').then(m => m.AUTH_ROUTES)
    },
    {
        path: 'register',
        loadChildren: () =>
            import('./component/registration/registration.routes').then(m => m.REGISTRATION_ROUTES)
    },
    {
        path: '**',
        redirectTo: 'auth'
    }
];
